import { theme } from '../../theme/theme';

import { SVGRoot } from './ContentLoader';

export function Flow(props) {
  return (
    <SVGRoot
      className={props.className}
      style={props.style}
      role="img"
      width="300"
      height="40"
      aria-labelledby="loading-aria"
      viewBox="0 0 300 40"
      preserveAspectRatio="none"
    >
      <title id="loading-aria">Loading...</title>
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        clipPath="url(#clip-path-flow)"
        style={{
          fill: 'url(#fill-flow)',
        }}
      />
      <defs>
        <clipPath id="clip-path-flow">
          <rect x="0" y="0" rx="20" ry="20" width="300" height="40" />
        </clipPath>
        <linearGradient id="fill-flow">
          <stop offset="0.6" stopColor={theme.color.mono_100} stopOpacity="1">
            <animate
              attributeName="offset"
              values="-2; -2; 1"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="1.6" stopColor={theme.color.mono_050} stopOpacity="1">
            <animate
              attributeName="offset"
              values="-1; -1; 2"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="2.6" stopColor={theme.color.mono_100} stopOpacity="1">
            <animate
              attributeName="offset"
              values="0; 0; 3"
              keyTimes="0; 0.25; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>
    </SVGRoot>
  );
}
